export default function initHamburger() {
  const hamburger = document.querySelector(".hamburger");
  const navigation = document.querySelector(".navigation");

  if (hamburger && navigation) {
    hamburger.addEventListener("click", () => {
      const isOpen = hamburger.classList.toggle("is-open");
      hamburger.setAttribute("aria-expanded", isOpen);
      hamburger.setAttribute(
        "aria-label",
        isOpen ? "メニューを閉じる" : "メニューを開く",
      );

      if (isOpen) {
        // scrollHeightで実際のコンテンツ高さを取得してセット
        navigation.style.maxHeight = navigation.scrollHeight + "px";
      } else {
        navigation.style.maxHeight = "0";
      }
    });

    // ナビリンククリックで閉じる
    navigation.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => {
        if (getComputedStyle(hamburger).display !== "none") {
          hamburger.classList.remove("is-open");
          navigation.style.maxHeight = "0";
          hamburger.setAttribute("aria-expanded", "false");
          hamburger.setAttribute("aria-label", "メニューを開く");
        }
      });
    });
  }
}
